import {createSelector} from 'reselect';
export const roles = state => state.roles;
export const rolesSelector = createSelector(roles, data => data);
